/* eslint-disable react/prop-types */
import { Checkbox } from '@tencent/tea-component';
import _ from 'lodash';
import React, { useEffect } from 'react';

// export interface Option {
//   label: string;
//   value: string | number;
//   name: string;
//   id?: string;
//   disabled?: boolean;
//   checked?: boolean;
// }

// export interface CheckboxProps {
//   name: string;
//   options: (Option[] | Option)[];
//   defaultValue: string | Array<string | number>;
//   onChange: (e: any) => any;
//   disabled?: boolean;
//   layout?: 'column' | 'inline';
//   className?: string;
//   style?: any;
// }

export default function CheckboxField(props) {
  const { options = [], value, defaultValue, ...restProps } = props;

  useEffect(() => {
    setTimeout(() => {
      const optionsChecked = _.find(options, (i) => !!i.checked);
      const finalDefaultValue = _.get(optionsChecked, 'value') || defaultValue || [];
      if (finalDefaultValue) {
        props.onChange([].concat(finalDefaultValue));
      }
    });
  }, []);

  return (
    <Checkbox.Group {...restProps} value={value || defaultValue}>
      {options.map((option, index) => {
        const { text, label, value, checked, ...restProps } = option;
        const finalLabel = label || text;
        const renderLabel = <span>{label || text}</span>;
        const key = `${value}${index}`;
        return (
          <Checkbox {...restProps} name={value || finalLabel} key={key}>
            {renderLabel}
          </Checkbox>
        );
      })}
    </Checkbox.Group>
  );
}

CheckboxField.defaultProps = {};
